import React, { useRef } from 'react';
import { Polygon } from '@react-google-maps/api';

const ZonePolygon = (props) => {
  // Holds the google.maps.Polygon instance (set via onLoad). We intentionally do
  // NOT pass `ref` to <Polygon>: it is a class component, so a ref resolves to
  // the React instance (no getPath()) and is attached after onLoad, clobbering
  // the value we store here.
  const polygonRef = useRef(null);
  // Handles for the path listeners WE add, so we can remove exactly those on
  // unmount. Using google.maps.event.clearListeners() would also strip the
  // listeners Google Maps installs for interactive editing and break dragging.
  const listenersRef = useRef([]);

  const convertToArrayPath = (polygonArray) =>
    polygonArray.map((vertex) => ({
      lat: vertex.lat(),
      lng: vertex.lng(),
    }));

  const reportChange = () => {
    const { onChange } = props;
    const polygon = polygonRef.current;
    if (polygon && polygon.getPath) {
      onChange && onChange(convertToArrayPath(polygon.getPath().getArray()));
    }
  };

  const onRightClick = (e) => {
    const { minVertexCount } = props;
    const polygon = polygonRef.current;
    if (!polygon || e.vertex === undefined) {
      return;
    }
    const path = polygon.getPath();
    if (path.getLength() > minVertexCount) {
      path.removeAt(e.vertex);
      reportChange();
    }
  };

  const onMouseUp = (e) => {
    // Right-clicking a vertex removes it; a normal (left button) mouse up after
    // dragging or adding a vertex reports the new path.
    if (e?.vertex !== undefined && e?.domEvent?.which !== 1) {
      return onRightClick(e);
    }
    reportChange();
  };

  const onLoad = (polygon) => {
    polygonRef.current = polygon;
    const path = polygon.getPath();
    listenersRef.current.push(
      window.google.maps.event.addListener(path, 'set_at', reportChange),
      window.google.maps.event.addListener(path, 'insert_at', reportChange),
      window.google.maps.event.addListener(path, 'remove_at', reportChange)
    );
  };

  const onUnmount = () => {
    listenersRef.current.forEach((listener) => window.google.maps.event.removeListener(listener));
    listenersRef.current = [];
    polygonRef.current = null;
  };

  return (
    <Polygon
      {...props}
      onLoad={onLoad}
      onUnmount={onUnmount}
      onMouseUp={onMouseUp}
      onRightClick={onRightClick}
    />
  );
};

ZonePolygon.defaultProps = {
  editable: false,
  visible: true,
  minVertexCount: 3,
};

export default ZonePolygon;
